<div class="property" *ngFor="let property of properties">
    <b class="title">{{property.title}}</b>
    <div class="description">{{property.description}}</div>
    <div class="type">{{property.type}} <ng-container *ngIf="property.type=='relation'">| {{property.relationType}}</ng-container></div>
    <div class="default">{{property.default}}</div>
</div>